<div class="loading-wrapper flex column vcenter hcenter">
  <img
    src="assets/shared/global-images/payee-logos/v1/white-payee-with-badge.svg"
    width="149px"
    alt="Payee"
  />
  <img
    src="assets/Bean Eater-1s-207px.svg"
    height="95px"
    class="loading-animation"
    alt=""
  />
</div>
